import axios from 'axios';

let access_token = localStorage.getItem('access_token')

const baseURL = process.env.REACT_APP_URL_API

const api = axios.create({
    baseURL,
    headers: {
        Authorization: `Bearer ${access_token}`
    }
});

api.interceptors.response.use(
    (response) => {
        return response;
    },
    async function (error) {

        const originalConfig = error.config;
        const access_token = localStorage.getItem("access_token");

        if(error.response.status === 404) {
           // window.location.href = '/';
        }

        if (error.response.status === 401 && access_token) {
            console.log('401')
            const response = await refreshToken(error)

            error.response.config.headers["Authorization"] = `Bearer ${response}`

            return api.request(originalConfig);
        }

        return Promise.reject(error);

});

async function refreshToken(error) {
    return new Promise((resolve, reject) => {
        try {
            const header = {
                "Content-Type": "application/json",
                Accept: "application/json",
            };

            const body = {
                device_name: "postman",
                usref: localStorage.getItem('usref'),
                // Corte IT:536: reaproveita o ID token do Azure guardado no login (best-effort).
                azure_token: localStorage.getItem('azure_id_token') || undefined
            };

            axios
                .post(
                    process.env.REACT_APP_URL_API + "/sanctum/token",
                    body,
                    { headers: header }
                )
                .then((res) => {
                    console.log('REFRESH', res);
                    localStorage.setItem("access_token", res.data.access_token);
                    resolve(res.data.access_token);
                })
                .catch((err) => {
                    console.log('deu erro', err.message);
                    reject(error);
                });
        } catch (err) {
            reject(err);
        }
    });
}



export default api;



